import { render } from "./TheReportViewer.vue?vue&type=template&id=0cbcd5ef"
import script from "./TheReportViewer.vue?vue&type=script&lang=js"
export * from "./TheReportViewer.vue?vue&type=script&lang=js"

import "./TheReportViewer.vue?vue&type=style&index=0&id=0cbcd5ef&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__